export default "__VITE_ASSET__50f92fda__"